import store from '@/store'

/**
 * Set project and integration info
 * so its in a stand format for the api
 */

export default {
  before: {
    all: context => {
      const { service, ...params } = context.params
      context.params = {
        ...params,
        provider: {
          account_provider_id: store.state.provider.account_provider_id,
          service
        },
        account_id: store.state.account.id,
        site_id: store.state.site.id
      }
      return context
    }
  }
}
